import React from 'react';

import styles from './Footer.module.scss';

const Footer = (): JSX.Element => {
  return (
    <footer
      className={styles.footer}
    ></footer>
  );
};

export default Footer;
